import { useState } from "react";

export const StpViewerUseBetween = () => {
  const [is3dMode, set3dMode] = useState<boolean>(false);
  return {
    is3dMode,
    set3dMode
  }
}